import * as moment from 'moment'
import { uuid, mobileCheck } from "./UtilsService";
import { http_mkt } from "@/services/HttpService";
import mixpanel from 'mixpanel-browser';

export default class EventService {
  events = []
  eventsMixpanel = []
  loading = false;
  isMobile = false;

  constructor() {
    try {
      mixpanel.init('33fdce2b8500301526e8a5ab54d39395');
    } catch(e) {
      console.error("Failed to init mixpanel")
    }

    this.setUserInformation()
    this.startCollectingEvents()
  }

  track(name) {
    try{
      const event = this.getEventObject(name)

      if(process.env.NODE_ENV === 'development'
      && process.env.VUE_APP_TRACKING_DEBUG)
        console.log(event)

      this.events.push(event)
      if(mixpanel) this.eventsMixpanel.push(event)

    } catch(e) {
      console.error(e)
    }
  }

  getEventObject(name) {
    const metadata = {
      version: process.env.VUE_APP_VERSION,
      mobile: this.isMobile,
      timestamp: moment().unix(),
    }

    return {
      name,
      description: '', // legacy
      group: '', // legacy
      category: '', // legacy
      action: '', // legacy
      label: '', // legacy
      value: JSON.stringify(metadata), // legacy
      created_at: moment().format(),
      version: process.env.VUE_APP_VERSION,
      metadata
    }
  }

  collect() {
    if(process.env.NODE_ENV !== 'production') return;
    if(!this.events.length) return;
    if(!this.session) return;

    this.loading = true;

    http_mkt.post(`/yooga/events`, {
      session: this.session,
      events: this.events
    }).then(() => {
      this.events = []
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  }

  collectMixpanel() {
    if(process.env.NODE_ENV !== 'production') return;
    if(!this.eventsMixpanel.length) return;
    if(!this.session) return;

    for(let event of this.eventsMixpanel) try {
      mixpanel.track(event.name, {
        ...event,
        session: this.session,
      })
    } catch(error) {
      console.error(error)
    }

    this.eventsMixpanel = []
  }

  setUserInformation() {
    if(this.session) return;

    this.session = uuid()
    this.isMobile = mobileCheck()
  }

  startCollectingEvents() {
    setInterval(() => {
      if(!this.session) this.setUserInformation();

      this.collectMixpanel();

      if(this.loading) return;
      this.collect();
    }, 6000)
  }
}
